import { useState } from 'react';
import { api } from '../lib/api';

export function RequestAccess() {
  const [body, setBody] = useState({ email: '', fullName: '', requestedRole: 'adviser' as 'adviser' | 'principal_adviser' | 'support_staff' | 'compliance_officer', reason: '' });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    try { await api('/api/onboarding/request-access', { method: 'POST', body: JSON.stringify(body) }); }
    finally { setDone(true); setBusy(false); }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <p className="qa-eyebrow mb-3 text-center">Request access</p>
        <h1 className="qa-h1 text-center mb-6">Join the <span className="qa-italic-accent">platform.</span></h1>
        {done ? (
          <div className="qa-card p-8 text-center">
            <p>Your request is in. The admin team will email you when it's reviewed.</p>
            <a href="/" className="btn-ghost mt-4 inline-block">← Back to sign in</a>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="qa-card p-8 space-y-4">
            <div>
              <label className="qa-label">Full name</label>
              <input type="text" required className="qa-input" value={body.fullName} onChange={e => setBody(b => ({ ...b, fullName: e.target.value }))} />
            </div>
            <div>
              <label className="qa-label">Work email</label>
              <input type="email" required className="qa-input" value={body.email} onChange={e => setBody(b => ({ ...b, email: e.target.value }))} />
            </div>
            <div>
              <label className="qa-label">Requested role</label>
              <select className="qa-select" value={body.requestedRole} onChange={e => setBody(b => ({ ...b, requestedRole: e.target.value as typeof b.requestedRole }))}>
                <option value="adviser">Adviser</option>
                <option value="principal_adviser">Principal adviser</option>
                <option value="support_staff">Support staff</option>
                <option value="compliance_officer">Compliance officer</option>
              </select>
            </div>
            <div>
              <label className="qa-label">Reason (optional)</label>
              <textarea className="qa-textarea min-h-[80px]" value={body.reason} onChange={e => setBody(b => ({ ...b, reason: e.target.value }))} />
            </div>
            <button className="btn-primary w-full" disabled={busy}>{busy ? 'Sending…' : 'Submit request'}</button>
            <a href="/" className="block text-center text-xs text-ink-mute hover:text-rust">← Back to sign in</a>
          </form>
        )}
      </div>
    </div>
  );
}
